import React from 'react';
import MaskedInput from 'src/ui/library/MaskedInput/MaskedInput';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const currencyMask = rawValue => {
  let numberMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    decimalLimit: 2,
    requireDecimal: true,
  });
  rawValue = rawValue === null || typeof rawValue === 'undefined' ? '' : rawValue.toString();
  rawValue = rawValue && rawValue.indexOf('.') === 0 ? `0${rawValue}` : rawValue;
  let mask = numberMask(rawValue);

  return mask;
};

//function for handling decimal places.
const currencyBlur = (event, props) => {
  let mask = event.target.value;
  // in case value is inputted then check for decimal places.
  if (mask) {
    mask = mask.indexOf('.') === 0 ? `0${mask}` : mask;
    const decimalsRegex = /\.([0-9]{1,2})/;
    const result = decimalsRegex.exec(event.target.value);

    // In case there is only one decimal
    if (result && result[1].length < 2) {
      mask += '0';
    } else if (!result) {
      // in case user didn't input a decimal then add decimal also
      if (mask.indexOf('.') === -1) mask += '.00';
      // else add decimal places
      else mask += '00';
    }

    //pass back the changed value to save in state
    if (mask !== event.target.value && props.onChange) {
      props.onChange({ target: { value: mask } });
    }
  }
  //pass event to existing blur if defined.
  if (props.onBlur) {
    props.onBlur(event);
  }
};

const setInputRef = (maskedInputRef, inputRef, forwardedRef) => {
  const inputElement = maskedInputRef ? maskedInputRef.inputElement : null;

  if (typeof inputRef === 'function') {
    inputRef(inputElement);
  }

  if (typeof forwardedRef === 'function') {
    forwardedRef(inputElement);
  } else if (forwardedRef) {
    forwardedRef.current = inputElement;
  }
};

const NumberMask = React.forwardRef((props, ref) => {
  const { inputRef, onChange, value, ...other } = props;
  return (
    <MaskedInput
      {...other}
      onChange={onChange}
      value={value}
      onBlur={e => currencyBlur(e, props)}
      ref={maskedInputRef => setInputRef(maskedInputRef, inputRef, ref)}
      mask={currencyMask}
      guide={false}
      showMask
    />
  );
});

NumberMask.displayName = 'NumberMask';

NumberMask.propTypes = {
  inputRef: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default NumberMask;
